import React from "react";
import LoginPage from "components/Login/LoginPage";

import urlServices from "services/urlServices";
import deviceServices from "services/deviceServices";

import login_logo from "images/custom/logo.jpg";

import "./Login.css";

class GptsLoginPage extends LoginPage {
  render() {
    return (
      <div className="login-register-container container verticalpadding">
        <div className="innerblock pure-g">
          <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
            <div className="logo-container">
              <img src={login_logo} alt="Logo" className="logo-img" />
            </div>
            <h2 className="login-title">Get Paid To Speak</h2>

            <form
              className="pure-form"
              onSubmit={this.handlePreSubmit.bind(this)}
            >
              {this.renderLoginFields()}
              {/* Add hidesso=true to query string in order to hide sso login, e.g. /login?hidesso=true */}
              {urlServices.getUrlParamValueByKey("hidesso") !== "true" &&
                !deviceServices.isWebView() &&
                this.renderSSOLoginSection()}
              {this.renderRegisterSection()}
            </form>
          </div>
          <div className="pure-u-sm-4-24 pure-u-md-6-24" />
        </div>
      </div>
    );
  }
}

export default GptsLoginPage;
